var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Loading", { attrs: { loadingHide: _vm.loadingHide } }),
      _vm._v(" "),
      _c("Header"),
      _vm._v(" "),
      _c("div", { staticClass: "container worksContent" }, [
        _c("div", { staticClass: "works-content" }, [
          _c("div", { staticClass: "works-content-title" }, [
            _c("div", { staticClass: "works-content-title-left" }, [
              _c("span", { staticClass: "workName" }, [
                _vm._v(_vm._s(_vm.worksName)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "workTime" }, [
                _vm._v(
                  _vm._s(
                    `发布于：${_vm.createDate} ${
                      _vm.updateDate ? "更新于：" + _vm.updateDate : ""
                    }`
                  )
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "workControl" }, [
                _c("div", [
                  _c("i", { staticClass: "el-icon-view" }),
                  _vm._v(" " + _vm._s(_vm.visNum)),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "giveLikeBox" },
                  [
                    _c("svg-icon", {
                      staticClass: "commend",
                      attrs: {
                        "icon-class": _vm.zansStatus ? "zan-active" : "zan",
                      },
                      on: { click: _vm.giveLike },
                    }),
                    _vm._v(" "),
                    _c("i", [_vm._v(_vm._s(_vm.likeNum))]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "collectBox" }, [
                  _c("span", {
                    class: _vm.collectionStatus ? "collectLike" : "collect",
                    on: { click: _vm.enshrine },
                  }),
                  _vm._v(
                    "\n                            收藏\n                        "
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "works-content-title-right" }, [
              _c("img", {
                attrs: { src: _vm.authorAvatar, alt: "" },
                on: {
                  click: function ($event) {
                    return _vm.goUserHome(_vm.authorId)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  on: {
                    click: function ($event) {
                      return _vm.goUserHome(_vm.authorId)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.authorName))]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "works-content-content" }, [
            _c("div", { staticClass: "works-ralative" }, [
              _vm.scratchLoading
                ? _c("div", { staticClass: "worksLoading" }, [
                    _c("img", { attrs: { src: _vm.themeData.logo, alt: "" } }),
                    _vm._v(" "),
                    _c("div", { staticClass: "scratch-loading" }, [
                      _c("div", {
                        staticClass: "filled",
                        style: `width: ${_vm.width}%`,
                      }),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { attrs: { id: "scratch-player" } }),
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.keyboard != 1,
                      expression: "keyboard != 1",
                    },
                  ],
                  staticClass: "panel-container f-cb",
                },
                [
                  _vm.keyboard == 2
                    ? _c("div", { staticClass: "keyboardBox" }, [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "space f-fr",
                          attrs: { id: "mspaceBtn" },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "q", attrs: { id: "mqBtn" } },
                          [_vm._v("Q")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "w", attrs: { id: "mwBtn" } },
                          [_vm._v("W")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "e", attrs: { id: "meBtn" } },
                          [_vm._v("E")]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.keyboard == 3
                    ? _c("div", { staticClass: "keyboardBox" }, [
                        _vm._m(1),
                        _vm._v(" "),
                        _vm._m(2),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.keyboard == 4
                    ? _c("div", { staticClass: "keyboardBox" }, [_vm._m(3)])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "playGame", attrs: { id: "playGame" } },
                    [_vm._v("开始")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "stopGame", attrs: { id: "stopGame" } },
                    [_vm._v("结束")]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "heatWorkShow" }, [
                _c("div", { staticClass: "heatWork" }, [
                  _c(
                    "div",
                    [
                      _c("svg-icon", { attrs: { "icon-class": "zan" } }),
                      _vm._v(
                        _vm._s(_vm.likeNum) +
                          "\n                                "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _c("i", { staticClass: "el-icon-view" }),
                    _vm._v(_vm._s(_vm.visNum)),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "works-content-info" }, [
                _vm._m(4),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.works_info_tab == "intro",
                        expression: "works_info_tab == 'intro'",
                      },
                    ],
                    staticClass: "worksIntro",
                  },
                  [_vm._v(_vm._s(_vm.description))]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.works_info_tab == "explain",
                        expression: "works_info_tab == 'explain'",
                      },
                    ],
                    staticClass: "explain",
                  },
                  [_vm._v(_vm._s(_vm.direction))]
                ),
              ]),
              _vm._v(" "),
              _vm._m(5),
              _vm._v(" "),
              _c("div", { staticClass: "works_fun" }, [
                _c("div", { on: { click: _vm.handleGeneratePoster } }, [
                  _c("i", { staticClass: "el-icon-picture-outline" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "li-title" }, [_vm._v("生成海报")]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.$router.push({
                          name: "sh",
                          query: { id: _vm.worksId },
                        })
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "el-icon-tickets" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("查看代码")]),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "comment" }, [
          !_vm.loginStatus
            ? _c("div", { staticClass: "commentTitle" }, [
                _c("span", [
                  _c("i", { on: { click: _vm.contentLogin } }, [
                    _vm._v("登录"),
                  ]),
                  _vm._v("之后才能评论哦"),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.loginStatus
            ? _c(
                "div",
                { staticClass: "commentText" },
                [
                  _c("div", { staticClass: "po-re" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.commentText,
                          expression: "commentText",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        rows: "4",
                        maxlength: "140",
                        placeholder:
                          "记得保持言论友善和谦虚哦，互相学习，共同进步。",
                      },
                      domProps: { value: _vm.commentText },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.commentText = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "hky-write" }, [
                      _vm._v("还可以输入"),
                      _c("span", [_vm._v(_vm._s(_vm.commentTextNum))]),
                      _vm._v("个字"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: { click: _vm.postComment },
                    },
                    [_vm._v("留言")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "commentList" }, [
            _c(
              "ul",
              { staticClass: "commentList-list" },
              _vm._l(_vm.commentList, function (comment, index) {
                return _c("li", { key: index }, [
                  _c("img", {
                    attrs: { src: comment.reviewerAvatar, alt: "" },
                    on: {
                      click: function ($event) {
                        return _vm.goUserHome(comment.reviewerId)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "commentUserInfo" }, [
                    _c(
                      "span",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.goUserHome(comment.reviewerId)
                          },
                        },
                      },
                      [_vm._v(_vm._s(comment.reviewerName))]
                    ),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(comment.createDate))]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(comment.content))]),
                    _vm._v(" "),
                    _c("div", { staticClass: "reply" }, [
                      _vm.userInfo != null
                        ? _c(
                            "i",
                            {
                              staticClass: "el-icon-chat-line-square",
                              on: {
                                click: function ($event) {
                                  return _vm.setReply(comment.id)
                                },
                              },
                            },
                            [_vm._v("回复")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userInfo != null &&
                      _vm.userInfo.id == comment.reviewerId
                        ? _c(
                            "i",
                            {
                              staticClass: "el-icon-delete",
                              on: {
                                click: function ($event) {
                                  return _vm.deleteComment(
                                    comment.id,
                                    "comment",
                                    index
                                  )
                                },
                              },
                            },
                            [_vm._v("删除")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.replyId == comment.id
                        ? _c(
                            "div",
                            [
                              _c("div", { staticClass: "po-re" }, [
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: comment[index],
                                      expression: "comment[index]",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { rows: "4", maxlength: "140" },
                                  domProps: { value: comment[index] },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        comment,
                                        index,
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticClass: "worksContent-reply",
                                  attrs: { type: "primary", plain: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.postReply(
                                        comment[index],
                                        comment
                                      )
                                    },
                                  },
                                },
                                [_vm._v("回复")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "discussionsList" }, [
                      _c(
                        "ul",
                        { staticClass: "discussionsList-list" },
                        _vm._l(
                          comment.discussions,
                          function (discussion, indexs) {
                            return _c("li", { key: indexs }, [
                              _c("img", {
                                attrs: {
                                  src: discussion.replierAvatar,
                                  alt: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.goUserHome(discussion.replierId)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "commentUserInfo" }, [
                                _c(
                                  "span",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.goUserHome(
                                          discussion.replierId
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(discussion.replierName))]
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(discussion.createDate)),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(discussion.content)),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "reply" }, [
                                  _vm.userInfo != null
                                    ? _c(
                                        "i",
                                        {
                                          staticClass:
                                            "el-icon-chat-line-square",
                                          on: {
                                            click: function ($event) {
                                              return _vm.setReply(
                                                discussion.id,
                                                discussion.replierName,
                                                index,
                                                indexs,
                                                discussion[indexs]
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("回复")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.userInfo != null &&
                                  _vm.userInfo.id == discussion.replierId
                                    ? _c(
                                        "i",
                                        {
                                          staticClass: "el-icon-delete",
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteComment(
                                                discussion.id,
                                                "discussion",
                                                indexs,
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.replyId == discussion.id
                                    ? _c(
                                        "div",
                                        [
                                          _c("div", { staticClass: "po-re" }, [
                                            _c("textarea", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: discussion[indexs],
                                                  expression:
                                                    "discussion[indexs]",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                rows: "4",
                                                maxlength: "140",
                                              },
                                              domProps: {
                                                value: discussion[indexs],
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    discussion,
                                                    indexs,
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "worksContent-reply",
                                              attrs: {
                                                type: "primary",
                                                plain: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.postReply(
                                                    discussion[indexs],
                                                    comment
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("回复")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]),
                              ]),
                            ])
                          }
                        ),
                        0
                      ),
                    ]),
                  ]),
                ])
              }),
              0
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("Foot"),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "宣传海报",
            width: "385px",
            visible: _vm.posterDialogVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.posterDialogVisible = $event
            },
            close: _vm.closePosterDialog,
          },
        },
        [
          _c("el-alert", {
            attrs: {
              title: "电脑端右键另存为;手机端复制保存本地",
              type: "info",
              center: "",
              "show-icon": "",
              closable: false,
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "posterBox" }, [
            _c("canvas", {
              attrs: { id: "poster", width: "345", height: "612" },
            }),
            _vm._v(" "),
            _vm.posterImgData
              ? _c("img", { attrs: { src: _vm.posterImgData, alt: "" } })
              : _vm._e(),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sxzu-bar-one" }, [
      _c("div", {
        staticClass: "key left arrow-left",
        attrs: { id: "mleftBtn" },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "key down arrow-down",
        attrs: { id: "mdownBtn" },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "key right arrow-right",
        attrs: { id: "mrightBtn" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "key up arrow-up", attrs: { id: "mupBtn" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sxzu-bar" }, [
      _c("div", {
        staticClass: "key left arrow-left",
        attrs: { id: "mleftBtn" },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "key down arrow-down",
        attrs: { id: "mdownBtn" },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "key right arrow-right",
        attrs: { id: "mrightBtn" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "key up arrow-up", attrs: { id: "mupBtn" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sxzu-bar-wasd" }, [
      _c("div", { staticClass: "key keyW arrow-w", attrs: { id: "mwBtn" } }, [
        _vm._v("W"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key keyA arrow-a", attrs: { id: "maBtn" } }, [
        _vm._v("A"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key keyS arrow-s", attrs: { id: "msBtn" } }, [
        _vm._v("S"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key keyD arrow-d", attrs: { id: "mdBtn" } }, [
        _vm._v("D"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "num-keypad" }, [
      _c("div", { staticClass: "key number", attrs: { id: "m7Btn" } }, [
        _vm._v("7"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key number", attrs: { id: "m8Btn" } }, [
        _vm._v("8"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key number", attrs: { id: "m9Btn" } }, [
        _vm._v("9"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key number", attrs: { id: "m4Btn" } }, [
        _vm._v("4"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key number", attrs: { id: "m5Btn" } }, [
        _vm._v("5"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key number", attrs: { id: "m6Btn" } }, [
        _vm._v("6"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key number", attrs: { id: "m1Btn" } }, [
        _vm._v("1"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key number", attrs: { id: "m2Btn" } }, [
        _vm._v("2"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key number", attrs: { id: "m3Btn" } }, [
        _vm._v("3"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "works_info_tab" }, [
      _c("span", { staticClass: "title" }, [_vm._v("作品简介")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "erweimaBox" }, [
      _c("span", { staticClass: "title" }, [_vm._v("作品二维码")]),
      _vm._v(" "),
      _c("div", { staticClass: "weixinImgBox" }, [
        _c("div", { attrs: { id: "qrcode" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/worksContent.vue?vue&type=template&id=61694727&
// module id = null
// module chunks = 